import { OwnMoneyQuestion } from '@hb/domain/steps/extra-asset';
import { FieldSubject } from '@hb/domain/field-subject';
import { ExtraAssetStoreService } from '@hb/modules/extra-asset/extra-asset-store.service';
import { money } from '@hb/builder';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';

import { ExtraAsset } from '@ap/ap-interface-apix-hypotheken-berekening';
import { Money } from '@ap/interface-bspc-core';

@Injectable({
    providedIn: 'root'
})
export class OwnMoneyPartStoreService extends AbstractStoreInjectOption<OwnMoneyQuestion> implements OnDestroy {
    protected readonly store = inject(ExtraAssetStoreService);
    protected readonly lastQuestion = OwnMoneyQuestion.SUMMARY;

    private readonly ownMoneySubject: FieldSubject<boolean>;
    private readonly ownMoneyAmountSubject: FieldSubject<Money>;

    constructor() {
        super();
        this.init();
        const initialValues = this.getInitialValues();
        this.ownMoneySubject = new FieldSubject<boolean>(initialValues?.own_money);
        this.ownMoneyAmountSubject = new FieldSubject<Money>(initialValues?.own_money_amount);

        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.activeQuestionSubject.unsubscribe();
        this.ownMoneySubject.unsubscribe();
        this.ownMoneyAmountSubject.unsubscribe();
    }

    update(): void {
        this.store.setOwnMoney(this.ownMoneySubject.value);
        this.store.setOwnMoneyAmount(this.ownMoneyAmountSubject.value);
    }

    isActiveQuestion(question: OwnMoneyQuestion): boolean {
        switch (question) {
            case OwnMoneyQuestion.OWN_MONEY_BUTTON:
                return true;
            case OwnMoneyQuestion.OWN_MONEY_AMOUNT_INPUT:
                return this.ownMoneySubject.value;
            case OwnMoneyQuestion.SUMMARY:
            default:
                return false;
        }
    }

    getOwnMoney(): boolean {
        return this.ownMoneySubject.value;
    }

    setOwnMoney(ownMoney: boolean): void {
        this.ownMoneySubject.next(ownMoney);
    }

    getOwnMoneyAmount(): Money {
        return this.ownMoneyAmountSubject.value;
    }

    setOwnMoneyAmount(amount: string): void {
        this.ownMoneyAmountSubject.next(money(amount));
    }

    getInitialValues(): ExtraAsset {
        return this.store.getExtraAssetState();
    }

    private subscriptions(): void {
        this.ownMoneySubject.asObservable().subscribe((ownMoney: boolean) => {
            if (!ownMoney) {
                this.ownMoneyAmountSubject.next(null);
                this.update();
            } else {
                this.update();
            }
            this.nextQuestion();
        });
        this.ownMoneyAmountSubject.asObservable().subscribe(() => this.update());
    }
}
